import { createApp } from 'vue'
import App from './App.vue'

// Importar los estilos de PhotoSwipe
import 'photoswipe/style.css'

createApp(App).mount('#app')
